export const OPTION_QUESTION_TYPES = ['single_select', 'multi_select'];

export const questionTypeUsesOptions = (type: string | undefined): boolean => {
  return OPTION_QUESTION_TYPES.includes(type ?? 'single_select');
};
